import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { SwingWtPrefix } from '../../api/models';

export type TABLE_TYPE = Table<SwingWtPrefix>;

export const TABLE = 'swingWtPrefix';
const SCHEMA = 'swingWtPrefixId, sortId';

class SwingWtPrefixDatabase implements DataRepository<SwingWtPrefix> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<SwingWtPrefix | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: SwingWtPrefix, key: Key): Promise<SwingWtPrefix> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: SwingWtPrefix[]): Promise<SwingWtPrefix[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<SwingWtPrefix[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const SwingWtPrefixDB = new SwingWtPrefixDatabase(db);
